document.addEventListener('DOMContentLoaded', () => {
  const contents = document.querySelectorAll('.text-to-expend');

  contents.forEach(content => {
    const link = content.parentElement.querySelector('.see-more-link');
    if (!link) return;

    let expanded = false;

    // On stocke la hauteur clampée une fois pour toutes
    const clampedHeight = content.offsetHeight;

    // On prépare la hauteur auto mesurée (texte complet)
    // On retire clamp juste pour mesurer, sans animer
    content.classList.add('expanded');
    const fullHeight = content.scrollHeight;
    content.classList.remove('expanded');

    // Au clic
    link.addEventListener('click', e => {
      e.preventDefault();

      if (!expanded) {
        content.classList.add('expanded'); // clamp ajouté AVANT l’animation
        // OUVERTURE
        content.style.height = clampedHeight + 'px';
        content.offsetHeight; // reflow
        content.style.height = fullHeight + 'px';

        content.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'height') return;
          content.removeEventListener('transitionend', handler);

          content.style.height = ''; // auto
        });

        link.textContent = 'Voir moins';
      } else {
        // FERMETURE
        content.style.height = fullHeight + 'px';
        content.offsetHeight; // reflow
        content.style.height = clampedHeight + 'px';

        content.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName !== 'height') return;
          content.removeEventListener('transitionend', handler);

          content.classList.remove('expanded'); // clamp supprimé APRÈS l’animation
          content.style.height = '';
        });

        link.textContent = 'Voir plus';
      }

      expanded = !expanded;
    });
  });
});

